import { Button, Dialog } from '../components/ui';
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [request, setRequest] = useState(null);
  const [notice, setNotice] = useState(null);
  const resolveRef = useRef(null);
  const confirm = useCallback((message, options = {}) => new Promise(resolve => {
    resolveRef.current?.(false);
    resolveRef.current = resolve;
    setRequest({ message, ...options });
  }), []);
  const finish = useCallback(value => {
    resolveRef.current?.(value);
    resolveRef.current = null;
    setRequest(null);
  }, []);
  const notify = useCallback((message, type = 'error') => setNotice({ message, type }), []);
  useEffect(() => () => resolveRef.current?.(false), []);
  return <UIContext.Provider value={{ confirm, notify }}>
    {children}
    {request && <Dialog title={request.title || 'Подтвердите действие'} onClose={() => finish(false)}>
      <p className="confirm-message">{request.message}</p>
      <div className="dialog-actions"><Button autoFocus onClick={() => finish(false)}>Отмена</Button>
        <Button variant={request.variant || 'danger'} onClick={() => finish(true)}>{request.action || 'Подтвердить'}</Button></div>
    </Dialog>}
    {notice && <div className={`toast alert-${notice.type}`} role={notice.type === 'error' ? 'alert' : 'status'}>
      <span>{notice.message}</span><button className="icon-button" aria-label="Закрыть уведомление" onClick={() => setNotice(null)}>×</button>
    </div>}
  </UIContext.Provider>;
}

export const useUI = () => useContext(UIContext);
